import React, { useEffect, useState, useRef } from 'react';
import { ShoppingBag, X } from 'lucide-react';
const purchases = [{
  name: 'Marcela R.',
  province: 'Buenos Aires, Argentina',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 3 min'
}, {
  name: 'Prof. Rodrigo T.',
  province: 'Córdoba, Argentina',
  pack: 'MegaPack',
  time: 'hace 5 min'
}, {
  name: 'Dra. Carmen V.',
  province: 'Santiago, Chile',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 8 min'
}, {
  name: 'Alejandra M.',
  province: 'Ciudad de México, México',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 12 min'
}, {
  name: 'Lic. Patricia S.',
  province: 'Bogotá, Colombia',
  pack: 'MegaPack',
  time: 'hace 15 min'
}, {
  name: 'Gabriela F.',
  province: 'Lima, Perú',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 18 min'
}, {
  name: 'Prof. Daniel K.',
  province: 'Montevideo, Uruguay',
  pack: 'MegaPack',
  time: 'hace 22 min'
}, {
  name: 'Dra. Natalia B.',
  province: 'Quito, Ecuador',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 25 min'
}, {
  name: 'Carlos y María P.',
  province: 'San José, Costa Rica',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 30 min'
}, {
  name: 'Lic. Soledad H.',
  province: 'Asunción, Paraguay',
  pack: 'MegaPack',
  time: 'hace 35 min'
}, {
  name: 'Andrea L.',
  province: 'Guadalajara, México',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 40 min'
}, {
  name: 'Prof. Luciana M.',
  province: 'Medellín, Colombia',
  pack: 'MegaPack',
  time: 'hace 45 min'
}, {
  name: 'Roberto S.',
  province: 'Panamá, Panamá',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 50 min'
}, {
  name: 'Dra. Valentina C.',
  province: 'Santo Domingo, Rep. Dominicana',
  pack: 'MegaPack + Master-Pack',
  time: 'hace 55 min'
}, {
  name: 'Fernanda G.',
  province: 'La Paz, Bolivia',
  pack: 'MegaPack',
  time: 'hace 1 hora'
}];
export function SocialProofPopup() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  const timerRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const showNext = () => {
    setVisible(true);
    timerRef.current = setTimeout(() => {
      setVisible(false);
      timerRef.current = setTimeout(() => {
        setCurrentIndex(prev => (prev + 1) % purchases.length);
        showNext();
      }, 10000);
    }, 5000);
  };
  useEffect(() => {
    if (dismissed) return;
    timerRef.current = setTimeout(() => {
      showNext();
    }, 6000);
    return () => {
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [dismissed]);
  const handleDismiss = () => {
    setVisible(false);
    setDismissed(true);
    if (timerRef.current) clearTimeout(timerRef.current);
  };
  const current = purchases[currentIndex];
  const isMasterPack = current.pack.includes('Master-Pack');
  if (dismissed) return null;
  return <div className={`fixed bottom-4 left-4 right-4 md:left-6 md:right-auto md:max-w-sm z-50 transition-all duration-300 ease-out ${visible ? 'translate-y-0 opacity-100' : 'translate-y-20 opacity-0 pointer-events-none'}`} data-id="element-256">
      <div className={`relative rounded-2xl p-4 shadow-2xl backdrop-blur-sm ${isMasterPack ? 'bg-gradient-to-r from-navy-800 to-navy-900 border-2 border-gold-500 shadow-[0_0_25px_rgba(234,179,8,0.2)]' : 'bg-navy-800 border border-cosmic-600'}`} data-id="element-257">
        <button onClick={handleDismiss} className="absolute top-2 right-2 text-slate-500 hover:text-slate-300 p-1" data-id="element-258">
          <X className="w-3.5 h-3.5" data-id="element-259" />
        </button>

        <div className="flex items-start gap-3 pr-4" data-id="element-260">
          <div className={`flex-shrink-0 w-10 h-10 rounded-full flex items-center justify-center ${isMasterPack ? 'bg-gold-500/20 text-gold-400' : 'bg-cosmic-500/20 text-cosmic-400'}`} data-id="element-261">
            <ShoppingBag className="w-5 h-5" data-id="element-262" />
          </div>

          <div className="min-w-0" data-id="element-263">
            <p className="text-white font-semibold text-sm leading-tight" data-id="element-264">
              {current.name}
              <span className="text-slate-400 font-normal" data-id="element-265">
                {' '}
                — {current.province}
              </span>
            </p>
            <p className={`text-sm font-bold mt-0.5 ${isMasterPack ? 'text-gold-400' : 'text-cosmic-400'}`} data-id="element-266">
              {isMasterPack ? '🏆 ' : '💙 '}
              {current.pack}
            </p>
            <p className="text-[11px] text-slate-500 mt-1" data-id="element-267">
              {current.time} · ✅ Compra verificada
            </p>
          </div>
        </div>
      </div>
    </div>;
}